import React from 'react';
import Tabs from 'react-scale/components/elements/tabs';
import GenerationExample from 'react-scale/components/pages/catalog/generation';
import AttributeEnrichmentExample from 'react-scale/components/pages/catalog/attribute-enrichment';
import MatchingExample from 'react-scale/components/pages/catalog/matching';

const Example: React.FC<{ tabs: { title: 'Forge' | 'Attribute Enrichment' | 'Matching' }[] }> = ({
  tabs
}) => (
  <div className="xl:h-[550px]">
    <>
      <Tabs
        tabs={tabs?.map(tab => ({
          title: tab.title,
          content: tabsContent[tab.title]
        }))}
      />
    </>
  </div>
);

const tabsContent = {
  Forge: <GenerationExample />,
  'Attribute Enrichment': <AttributeEnrichmentExample />,
  Matching: <MatchingExample />
};

export default Example;
